module.exports = __webpack_public_path__ + "img/boqinspect6_7-8-2021.6b6aac2c.jpg";